import {CHANGE_USER_SETTINGS_CALENDAR, CHANGE_USER_SETTINGS_LANGUAGE, CHANGE_USER_SETTINGS_DOUBLE_CLICK} from '../actions/UserSettings';

const initialState = {
    language: "fa",
    calendar: "Solar Hejri",
    doubleClickAction: "Quick View"
};


const UserSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_USER_SETTINGS_DOUBLE_CLICK:
            return {
                doubleClickAction: action.payload.doubleClickAction
            };
        default:
            return state;
    }
};


export default UserSettingsReducer;
